<div
  *ngIf="isNegativeUser(influencer)"
  matTooltip="条件通りの投稿をいただけない可能性のあるユーザーです"
  matTooltipPosition="right"
>
  <span class="material-icons-two-tone">warning</span>
  <span class="material-icons">warning</span>
</div>
